"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var challenge_1 = require("./challenge");
var from_string_1 = require("uint8arrays/from-string");
var uuid_1 = require("uuid");
var to_string_1 = require("uint8arrays/to-string");
var events_1 = __importDefault(require("events"));
var author_1 = __importDefault(require("./author"));
var assert_1 = __importDefault(require("assert"));
var signer_1 = require("./signer");
var plebbit_logger_1 = __importDefault(require("@plebbit/plebbit-logger"));
var version_1 = __importDefault(require("./version"));
var signatures_1 = require("./signer/signatures");
var util_1 = require("./util");
var Publication = /** @class */ (function (_super) {
    __extends(Publication, _super);
    function Publication(props, plebbit) {
        var _this = _super.call(this) || this;
        _this.plebbit = plebbit;
        _this._initProps(props);
        return _this;
    }
    Publication.prototype._initProps = function (props) {
        var _a;
        this.subplebbitAddress = props.subplebbitAddress;
        this.timestamp = props.timestamp;
        this.signer = this.signer || props["signer"];
        this.signature = new signer_1.Signature(props.signature);
        (0, assert_1.default)((_a = props.author) === null || _a === void 0 ? void 0 : _a.address, "publication.author.address need to be defined");
        this.author = new author_1.default(props.author);
        this.protocolVersion = props.protocolVersion;
    };
    // TODO make this private/protected
    Publication.prototype.getType = function () {
        throw new Error("Should be implemented by children of Publication");
    };
    Publication.prototype.toJSON = function () {
        return __assign({}, this.toJSONSkeleton());
    };
    // TODO make this private/protected
    Publication.prototype.toJSONSkeleton = function () {
        return {
            subplebbitAddress: this.subplebbitAddress,
            timestamp: this.timestamp,
            signature: this.signature instanceof signer_1.Signature ? this.signature.toJSON() : this.signature,
            author: this.author.toJSON(),
            protocolVersion: this.protocolVersion
        };
    };
    Publication.prototype.handleChallengeExchange = function (pubsubMsg) {
        return __awaiter(this, void 0, void 0, function () {
            var log, msgParsed, challengeMsgValidity, decryptedChallenges, _a, _b, decryptedChallenge, signatureValidation, decryptedPublication, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        log = (0, plebbit_logger_1.default)("plebbit-js:publication:handleChallengeExchange");
                        msgParsed = JSON.parse((0, to_string_1.toString)(pubsubMsg["data"]));
                        if ((msgParsed === null || msgParsed === void 0 ? void 0 : msgParsed.challengeRequestId) !== this.challenge.challengeRequestId)
                            return [2 /*return*/]; // Process only this publication's challenge
                        if (!((msgParsed === null || msgParsed === void 0 ? void 0 : msgParsed.type) === "CHALLENGE")) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, signatures_1.verifyChallengeMessage)(msgParsed)];
                    case 1:
                        challengeMsgValidity = _e.sent();
                        if (!challengeMsgValidity.valid) {
                            log.error("Received a CHALLENGEMESSAGE with invalid signature. Failed verification reason: ".concat(challengeMsgValidity.reason));
                            return [2 /*return*/];
                        }
                        log("Received encrypted challenges.  Will decrypt and emit them on \"challenge\" event. User shoud publish solution by calling publishChallengeAnswers");
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, (0, signer_1.decrypt)(msgParsed.encryptedChallenges.encrypted, msgParsed.encryptedChallenges.encryptedKey, this.signer.privateKey)];
                    case 2:
                        decryptedChallenges = _b.apply(_a, [_e.sent()]);
                        decryptedChallenge = __assign(__assign({}, msgParsed), { challenges: decryptedChallenges });
                        this.emit("challenge", decryptedChallenge);
                        return [3 /*break*/, 9];
                    case 3:
                        if (!((msgParsed === null || msgParsed === void 0 ? void 0 : msgParsed.type) === "CHALLENGEVERIFICATION")) return [3 /*break*/, 9];
                        return [4 /*yield*/, (0, signatures_1.verifyChallengeVerification)(msgParsed)];
                    case 4:
                        signatureValidation = _e.sent();
                        if (!signatureValidation.valid) {
                            log.error("Received a CHALLENGEVERIFICATIONMESSAGE with invalid signature. Failed verification reason: ".concat(signatureValidation.reason));
                            return [2 /*return*/];
                        }
                        decryptedPublication = void 0;
                        if (!(msgParsed.challengeSuccess && msgParsed.encryptedPublication)) return [3 /*break*/, 6];
                        log("Challenge (".concat(msgParsed.challengeRequestId, ") has passed. Will update publication props from ChallengeVerificationMessage.publication"));
                        _d = (_c = JSON).parse;
                        return [4 /*yield*/, (0, signer_1.decrypt)(msgParsed.encryptedPublication.encrypted, msgParsed.encryptedPublication.encryptedKey, this.signer.privateKey)];
                    case 5:
                        decryptedPublication = _d.apply(_c, [_e.sent()]);
                        (0, assert_1.default)(decryptedPublication);
                        this._initProps(decryptedPublication);
                        return [3 /*break*/, 7];
                    case 6:
                        log.error("Challenge ".concat(msgParsed.challengeRequestId, " has failed to pass. Challenge errors = ").concat(msgParsed.challengeErrors, ", reason = '").concat(msgParsed.reason, "'"));
                        _e.label = 7;
                    case 7:
                        this.emit("challengeverification", __assign(__assign({}, msgParsed), { publication: decryptedPublication }), this);
                        return [4 /*yield*/, this.plebbit.pubsubIpfsClient.pubsub.unsubscribe(this.subplebbit.pubsubTopic)];
                    case 8:
                        _e.sent();
                        _e.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Publication.prototype.publishChallengeAnswers = function (challengeAnswers) {
        return __awaiter(this, void 0, void 0, function () {
            var log, encryptedChallengeAnswers, toSignAnswer, challengeAnswer, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (0, assert_1.default)(this.subplebbit, "Subplebbit is not defined");
                        log = (0, plebbit_logger_1.default)("plebbit-js:publication:publishChallengeAnswers");
                        if (!Array.isArray(challengeAnswers))
                            challengeAnswers = [challengeAnswers];
                        return [4 /*yield*/, (0, signer_1.encrypt)(JSON.stringify(challengeAnswers), this.subplebbit.encryption.publicKey)];
                    case 1:
                        encryptedChallengeAnswers = _d.sent();
                        toSignAnswer = {
                            type: "CHALLENGEANSWER",
                            challengeRequestId: this.challenge.challengeRequestId,
                            challengeAnswerId: (0, uuid_1.v4)(),
                            encryptedChallengeAnswers: encryptedChallengeAnswers,
                            userAgent: version_1.default.USER_AGENT,
                            protocolVersion: version_1.default.PROTOCOL_VERSION
                        };
                        _a = challenge_1.ChallengeAnswerMessage.bind;
                        _b = [__assign({}, toSignAnswer)];
                        _c = {};
                        return [4 /*yield*/, (0, signatures_1.signChallengeAnswer)(toSignAnswer, this.signer)];
                    case 2:
                        challengeAnswer = new (_a.apply(challenge_1.ChallengeAnswerMessage, [void 0, __assign.apply(void 0, _b.concat([(_c.signature = _d.sent(), _c)]))]))();
                        return [4 /*yield*/, this.plebbit.pubsubIpfsClient.pubsub.publish(this.subplebbit.pubsubTopic, (0, from_string_1.fromString)(JSON.stringify(challengeAnswer)))];
                    case 3:
                        _d.sent();
                        log("Responded to challenge (".concat(challengeAnswer.challengeRequestId, ") with answers"), challengeAnswers);
                        this.emit("challengeanswer", challengeAnswer);
                        return [2 /*return*/];
                }
            });
        });
    };
    Publication.prototype._validatePublicationFields = function () {
        var _a;
        if (typeof this.timestamp !== "number" || this.timestamp < 0)
            (0, util_1.throwWithErrorCode)("ERR_PUBLICATION_MISSING_FIELD", "".concat(this.getType(), ".publish: timestamp (").concat(this.timestamp, ") should be a positive number"));
        if (typeof ((_a = this.author) === null || _a === void 0 ? void 0 : _a.address) !== "string")
            (0, util_1.throwWithErrorCode)("ERR_PUBLICATION_MISSING_FIELD", "".concat(this.getType(), ".publish: author.address (").concat(this.author.address, ") should be a string"));
        if (typeof this.subplebbitAddress !== "string")
            (0, util_1.throwWithErrorCode)("ERR_PUBLICATION_MISSING_FIELD", "".concat(this.getType(), ".publish: subplebbitAddress should be a string"));
    };
    Publication.prototype._validateSubFields = function () {
        var _a, _b;
        if (typeof ((_b = (_a = this.subplebbit) === null || _a === void 0 ? void 0 : _a.encryption) === null || _b === void 0 ? void 0 : _b.publicKey) !== "string")
            (0, util_1.throwWithErrorCode)("ERR_SUBPLEBBIT_MISSING_FIELD", "".concat(this.getType(), ".publish: subplebbit.encryption.publicKey does not exist"));
        if (typeof this.subplebbit.pubsubTopic !== "string")
            (0, util_1.throwWithErrorCode)("ERR_SUBPLEBBIT_MISSING_FIELD", "".concat(this.getType(), ".publish: subplebbit.pubsubTopic does not exist"));
    };
    Publication.prototype.publish = function () {
        return __awaiter(this, void 0, void 0, function () {
            var log, options, _a, encryptedPublication, toSignMsg, _b, _c, _d;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        log = (0, plebbit_logger_1.default)("plebbit-js:publication:publish");
                        this._validatePublicationFields();
                        options = { acceptedChallengeTypes: [] };
                        _a = this;
                        return [4 /*yield*/, this.plebbit.getSubplebbit(this.subplebbitAddress)];
                    case 1:
                        _a.subplebbit = _f.sent();
                        this._validateSubFields();
                        return [4 /*yield*/, (0, signer_1.encrypt)(JSON.stringify(this), this.subplebbit.encryption.publicKey)];
                    case 2:
                        encryptedPublication = _f.sent();
                        toSignMsg = {
                            type: "CHALLENGEREQUEST",
                            encryptedPublication: encryptedPublication,
                            challengeRequestId: (0, uuid_1.v4)(),
                            acceptedChallengeTypes: options.acceptedChallengeTypes,
                            userAgent: version_1.default.USER_AGENT,
                            protocolVersion: version_1.default.PROTOCOL_VERSION
                        };
                        _b = this;
                        _c = challenge_1.ChallengeRequestMessage.bind;
                        _d = [__assign({}, toSignMsg)];
                        _e = {};
                        return [4 /*yield*/, (0, signatures_1.signChallengeRequest)(toSignMsg, this.signer)];
                    case 3:
                        _b.challenge = new (_c.apply(challenge_1.ChallengeRequestMessage, [void 0, __assign.apply(void 0, _d.concat([(_e.signature = _f.sent(), _e)]))]))();
                        log.trace("Attempting to publish ".concat(this.getType(), " with options"), options);
                        return [4 /*yield*/, Promise.all([
                                this.plebbit.pubsubIpfsClient.pubsub.publish(this.subplebbit.pubsubTopic, (0, from_string_1.fromString)(JSON.stringify(this.challenge))),
                                this.plebbit.pubsubIpfsClient.pubsub.subscribe(this.subplebbit.pubsubTopic, this.handleChallengeExchange.bind(this))
                            ])];
                    case 4:
                        _f.sent();
                        log("Sent a challenge request (".concat(this.challenge.challengeRequestId, ")"));
                        this.emit("challengerequest", this.challenge);
                        return [2 /*return*/];
                }
            });
        });
    };
    return Publication;
}(events_1.default));
exports.default = Publication;
